import {
  LOADED, LOADING,
} from "@/actions/types";

export default function (state = {}, action: {type: string}) {
  const { type } = action;

  switch (type) {
    case LOADING:
      return {
        ...state,
        state: true,
      };
    case LOADED:
      return {
        ...state,
        state: false,
      };
    default:
      return state;
  }
}
